import { AppBar, Stack, Toolbar, Divider } from '@mui/material';
import { HeaderWithScrollables, useFixedHeader } from '@diana/core';
import { CloseButton } from './Buttons/CloseButton';
import { SettingsButton } from './Buttons/SettingsButton';
import { HelpButton } from './Buttons/HelpButton';
import { AdvancedEditorButton } from './Buttons/AdvancedEditorButton';
import { ResetChangesButton } from './Buttons/ResetChangesButton';
import { PublishButton } from './Buttons/PublishButton';
import { SaveStatusIndicator } from './FormComponents/SaveStatusIndicator';

export const PerformanceReportBuilderPageNavbar = () => {
  const { headerRef, headerOffset } = useFixedHeader();
  return (
    <AppBar ref={headerRef} sx={{ position: 'fixed', top: headerOffset }}>
      <Toolbar
        variant="dense"
        sx={({ spacing }) => ({ height: spacing(6.5), px: 2 })}
        disableGutters
      >
        <HeaderWithScrollables
          left={<CloseButton />}
          right={
            <Stack direction="row" alignItems="center" spacing={1}>
              <SaveStatusIndicator />
              <SettingsButton />
              <HelpButton />
              <AdvancedEditorButton />
              <ResetChangesButton />
              <PublishButton />
            </Stack>
          }
        />
      </Toolbar>
      <Divider />
    </AppBar>
  );
};
